<template>
    <div
        class="animate-pulse"
        data-spec-class="table-skeleton"
    >
        <div class="mb-6 h-8 rounded-sm bg-muted" />
        <div
            v-for="index in rows"
            :key="index"
            :class="['mb-6 h-4 rounded-sm', isEven(index) ? 'bg-muted' : 'bg-secondary--inverse']"
            data-spec-class="table-skeleton-row"
        />
    </div>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue';
import { isEven } from '@/utils/templateUtils';

interface Props {
    rows?: number;
}

withDefaults(defineProps<Props>(), {
    rows: 10,
});
</script>
